import actions from './actions';
import { createReducer } from '../../../../helpers/reducer';

const initState = {
  sectors: null,
  loading: false,
  total: 0,
};

function onLoad(state) {
  return { ...state, loading: true, isEdit: false };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal } = payload;

  return { ...state, sectors: data, total, filteredTotal, loading: false };
}

function onClearStore() {
  return { ...initState };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
});
